export const statusLabel = status => {
  const mapping = {
    true: 'Выбрана',
    false: 'Добавлена',
  };

  return mapping[status];
};
